import { apiGetHomepageInformations } from '~/apiClient';

export default defineNuxtPlugin({
    name: 'fleequidStats',

    async setup() {
        const {
            _raw: { apiStats },
        } = useFleequidStats();
        const { logError } = useLogs();

        if (import.meta.server) {
            try {
                const data = await apiGetHomepageInformations();
                apiStats.value = data;
            } catch (error) {
                logError('Failed to fetch Fleequid stats', { error });
            }
        }
    },
});
